export default {
    store: {
        // 
    }
}



// WEBPACK FOOTER //
// ./src/config/vuex.js